export const secondsToHoursAndMinutes = (seconds: number | null | undefined): string => {
  if (seconds == null || seconds === 0) {
    return '0h';
  }

  const minutes = Math.floor(seconds / 60);

  const hours = Math.floor(minutes / 60);
  const remainingMinutes = Math.floor(minutes % 60);

  if (remainingMinutes === 0) {
    return `${hours}h`;
  }

  return `${hours}h ${remainingMinutes}m`;
};
